import application from 'application/application';

application.directive('ngQrCode', () => ({
	restrict: 'A',
	require: 'ngModel',
	link(scope, element, attrs, controller) {
		function formatAndUpdate(value) {
			if (!value) return '';

			let raw = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

			raw = raw.substring(0, 32);
			let formatted = raw.replace(/(.{4})/g, '$1 ').trim();

			controller.$setViewValue(formatted);
			controller.$render();

			return formatted;
		}

		element.on('input', () => {
			const formatted = formatAndUpdate(element.val());

			element.val(formatted);
		});

		// Inicialização do valor existente no model (caso exista)
		controller.$formatters.push(formatAndUpdate);
	}
}));
